import { inject } from "@angular/core";
import { CanActivateChildFn, Router } from "@angular/router";
import { usesManagedClientSelection } from "../pages/auth/model/managed-client-selection";
import { AuthStore } from "../pages/auth/store/auth.store";
import { catchError, map, of, switchMap } from "rxjs";
import { SignupEnrollmentService, enrollmentDestination } from '../pages/auth/services/signup-enrollment.service';

export const loadUserGuard: CanActivateChildFn = (childRoute, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const enrollment = inject(SignupEnrollmentService);
  const denied = () => authStore.accountAccessDenied();
  const deniedPage = () => router.createUrlTree(['/auth/access-denied'], {
    queryParams: { reason: authStore.accountAccessDeniedReason() ?? 'platform-service-staff-disabled' },
  });
  if (denied()) return deniedPage();
  const requireSelection = () => usesManagedClientSelection(authStore.role())
    && !authStore.activeOrganizationId();

  if (authStore.role() && authStore.user()) return requireSelection()
    ? router.createUrlTree(['/auth/select-organization']) : true;

  return enrollment.status().pipe(
    switchMap(status => {
      const destination = enrollmentDestination(status);
      return destination ? of(router.createUrlTree([destination], {
        queryParams: destination === '/auth/access-denied' ? { reason: 'signup-review' } : {},
      })) : authStore.loadUserInfo().pipe(
    map(() => denied() ? deniedPage() : requireSelection() ? router.createUrlTree(['/auth/select-organization']) : true),
      );
    }),
    catchError(() => of(false))
  );
};
